const healthData = [
    {
        id: 1,
        title: "تناسب اندام",
        img: "/images/ic_fitness.svg",
        link: "/sportClasses"
    },
    {
        id: 2,
        title: "برنامه تغذیه",
        img: "/images/ic_food_plan.svg",
        link: "/diets"
    },
    {
        id: 3,
        title: "چالش",
        img: "/images/ic_fitness.svg",
        link: "/challenge"
    },
    {
        id: 4,
        title: "مجله ورزشی",
        img: "/images/ic_journal.svg",
        link: "/magazines"
    },
    {
        id: 5,
        title: "محاسبه گر آنلاین",
        img: "/images/ic_online_calculator.svg",
        link: "/calculator"
    },
    {
        id: 6,
        title: "کالری شمار آنلاین",
        img: "/images/ic_chart_calorie.svg",
        link: "/calorieCounter"
    }
]

export default healthData